<template>
  <div>
    <v-container class="grey lighten-5" fluid>
      <v-row>
        <v-col cols="12">
          <h1>Dodaj stronę zapytania</h1>
          <v-card>
            <v-card-text>
              <v-form>
                <v-text-field v-model="pageDetails.title" label="Tytuł" hint="Tytuł wyświetlany w hero oraz nad formularzem"></v-text-field>

                <v-select
                    v-model="pageDetails.ownerId"
                    :items="owners"
                    item-value="id"
                    item-text="email"
                    label="Właściciel strony"
                    hint="Użytkownik z rolą „Właściciel strony”, który zobaczy w panelu partnera zamówienia i zapytania z tej strony"
                    persistent-hint
                    clearable
                ></v-select>

                <div class="mt-4 mb-2">Obrazek hero (opcjonalny)</div>
                <v-file-input
                    accept="image/*"
                    label="Wybierz obrazek"
                    prepend-icon="mdi-camera"
                    @change="onHeroImageSelected"
                ></v-file-input>
                <v-img v-if="pageDetails.heroImageUrl" :src="pageDetails.heroImageUrl" max-height="200" contain class="mb-4"></v-img>

                <div class="mt-4 mb-2">Tekst nad formularzem</div>
                <ckeditor
                    :editor="editor"
                    v-model="pageDetails.content"
                    :config="editorConfig"
                ></ckeditor>
              </v-form>
            </v-card-text>
          </v-card>
          <v-spacer/>
          <v-btn class="mt-2" @click="savePageDetails">
            Zapisz
            <v-icon size="24" right>mdi-content-save-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <modal-loader :show="loading" />
  </div>
</template>

<script>
import api from '../services/api';
import permissions from "@/mixins/permissions";
import ModalLoader from "../components/ModalLoader";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';

export default {
  components: {
    ModalLoader,
    ckeditor: CKEditor.component,
  },
  mixins: [permissions],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        ckfinder: {
          uploadUrl: process.env.VUE_APP_API_URL + '/api/files/image',
          options: {resourceType: 'Images'}
        },
        htmlSupport: {
          allow: [{name: /.*/, attributes: true, classes: true, styles: true}],
        },
      },
      loading: false,
      owners: [],
      pageDetails: {
        title: '',
        content: '',
        heroImageUrl: null,
        ownerId: null,
      },
    }
  },
  methods: {
    async getOwners() {
      const response = await api.get('/api/users?role=ROLE_PAGE_OWNER');
      this.owners = response.data.items;
    },
    async onHeroImageSelected(file) {
      if (!file) {
        return;
      }
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('upload', file);
        const response = await api.post('/api/files/image', formData);
        this.pageDetails.heroImageUrl = response.data.url;
      } catch (error) {
        this.$root.$emit('notifyError', {html: 'Nie udało się przesłać obrazka.', error});
      }
      this.loading = false;
    },
    async savePageDetails() {
      if (this.loading) {
        return
      }
      if (!this.pageDetails.title) {
        this.$root.$emit('notifyError', {html: 'Tytuł jest wymagany.'});
        return;
      }
      this.loading = true;
      try {
        const data = await api.post('/api/wholesale-inquiry-pages', this.pageDetails);
        this.$router.push({name: 'wholesale-inquiry-page-details', params: {id: data.data.id}});
      } catch (error) {
        this.loading = false;
        this.$root.$emit('notifyError', {html: 'Nie udało się zapisać strony.', error});
        return;
      }
      this.loading = false;
      this.$root.$emit('notifySuccess', {html: 'Strona została zapisana.'});
    },
  },
  created() {
    this.getOwners();
  },
}
</script>

<style scoped>
</style>
